// import { ACTIVITY_TYPE } from '@parent-app/config';
// import { DailyDiary, Observation, Pagination, TimelineData, TimelineStateType } from '@parent-app/types';
// import { getCurrentWeekEndDate } from '@parent-app/utils';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ACTIVITY_TYPE } from 'src/shared/config/src';
import { DailyDiary, Observation, Pagination, TimelineData, TimelineStateType } from 'src/shared/types/src';

const initialState: TimelineStateType = {
    timelineLoading: false,
    timelinePaginatedLoading: false,
    timelinePagination: {
        currentPage: 1,
        from: 1,
        itemsPerPage: 0,
        lastPage: 1,
        to: 1,
        totalItems: 1
    },
    timelineData: [],
    filters: {
        isFilterApplied: false,
        from: '',
        to: '',
        activityTypes: [],
        showFutureEvents: false
    },
    todaysDiary: []
}

const timelineSlice = createSlice({
    name: 'timelineSlice',
    initialState,
    reducers: {
        setTimelineLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.timelineLoading = action.payload.isLoading;
        },
        setTimelinePaginatedLoading: (state, action: PayloadAction<{ paginatedLoading: boolean }>) => {
            state.timelinePaginatedLoading = action.payload.paginatedLoading;
        },
        appendTimeLineData: (state, action: PayloadAction<{ timeline: TimelineData[], pagination: Pagination }>) => {
            state.timelinePagination = action.payload.pagination;
            state.timelineData = [...state.timelineData, ...action.payload.timeline];
        },
        resetTimelineState: (state) => {
            return {
                ...initialState,
                filters: state.filters,
                todaysDiary: state.todaysDiary
            }
        },
        resetTimelineAndFilters: (state) => {
            return {
                ...initialState,
                timelineLoading: true,
                todaysDiary: state.todaysDiary
            }
        },
        updateObservationDetailsInTimeline: (state, action: PayloadAction<{ observation: Observation }>) => {
            const timelineList = state.timelineData;
            const { observation } = action.payload;
            const observationIdx = timelineList.findIndex(obj => obj.activityType === ACTIVITY_TYPE.OBSERVATION && (obj?.id == observation.id));
            if (observationIdx === -1) {
                return;
            }
            const updatedObj: any = { ...timelineList[observationIdx], details: observation };
            state.timelineData = [
                ...timelineList.slice(0, observationIdx),
                updatedObj,
                ...timelineList.slice(observationIdx + 1),
            ];
        },
        updateDailyDiaryDetailsInTimeline: (state, action: PayloadAction<{ diary: DailyDiary, date: string }>) => {
            const timelineList = state.timelineData;
            const { diary, date } = action.payload;
            const dailyDiaryIdx = timelineList.findIndex((obj: TimelineData) => obj.activityType === ACTIVITY_TYPE.DAILY_DIARY && (obj?.details && obj?.details?.timestamp?.includes(date)));
            if (dailyDiaryIdx === -1) {
                return;
            }
            const updatedObj: any = { ...timelineList[dailyDiaryIdx], details: diary };
            state.timelineData = [
                ...timelineList.slice(0, dailyDiaryIdx),
                updatedObj,
                ...timelineList.slice(dailyDiaryIdx + 1),
            ];
        },
        updateAccidentSheetStatusInTimeline: (state, action: PayloadAction<{ accidentSheetID: string, status: string }>) => {
            const timelineList = state.timelineData;
            const { accidentSheetID, status } = action.payload;
            const sheetIdx = timelineList.findIndex(obj => obj.activityType === ACTIVITY_TYPE.ACCIDENT_SHEET && (obj?.id == accidentSheetID));
            if (sheetIdx === -1) {
                return;
            }
            const updatedObj: any = { ...timelineList[sheetIdx], status };
            state.timelineData = [
                ...timelineList.slice(0, sheetIdx),
                updatedObj,
                ...timelineList.slice(sheetIdx + 1),
            ];
        },
        updateMedicineFormStatusInTimeline: (state, action: PayloadAction<{ medicineFormID: string, status: string }>) => {
            const timelineList = state.timelineData;
            const { medicineFormID, status } = action.payload;
            // console.log("medicine form id : ", medicineFormID, status, JSON.stringify(timelineList, null, 2));
            const sheetIdx = timelineList.findIndex(obj => obj.activityType === ACTIVITY_TYPE.MEDICINE_FORM && (obj?.id == medicineFormID));
            console.log("sheet idx: ", sheetIdx);
            if (sheetIdx === -1) {
                return;
            }
            const updatedObj: any = { ...timelineList[sheetIdx], status };
            state.timelineData = [
                ...timelineList.slice(0, sheetIdx),
                updatedObj,
                ...timelineList.slice(sheetIdx + 1),
            ];
        },
        updateFilters: (state, action: PayloadAction<{ selectedTypes: string[], from: string, to: string, isFilterApplied: boolean, showFutureEvents: boolean }>) => {
            const { selectedTypes, from, to, isFilterApplied, showFutureEvents } = action.payload;
            // console.log("updating the filters in state : ", state, selectedTypes, from, to, isFilterApplied);
            state.filters = {
                activityTypes: selectedTypes,
                from,
                to,
                isFilterApplied,
                showFutureEvents
            }
        },
        setTodayDiary: (state, action: PayloadAction<{ timelineData: TimelineData[] }>) => {
            state.todaysDiary = action?.payload?.timelineData;
        },
        resetTodayDiaryState: (state) => {
            state.todaysDiary = [];
        },
    }
});

export const TimelineActions = timelineSlice.actions;
export default timelineSlice.reducer;